export default [
  {
    path: "/",
    name: "home",
    meta: {
      title: "HOME",
    },
    component: () => import("../views/pages/home/index.vue"),
  },
  {
    path: "/publicationDetails/:id",
    name: "publicationDetails",
    meta: {
      title: "PUBLICATION DETAILS",
    },
    component: () => import("../components/publication-details.vue"),
  },
  {
    path: "/about",
    name: "about",
    meta: {
      title: "ABOUT",
    },
    component: () => import("../views/pages/about/index.vue"),
  },
  {
    path: "/mandate",
    name: "mandate",
    meta: {
      title: "MANDATE",
    },
    component: () => import("../views/pages/mandate/index.vue"),
  },
  {
    path: "/news",
    name: "news",
    meta: {
      title: "NEWS",
    },
    component: () => import("../views/pages/news/index.vue"),
  },
  {
    path: "/news/:id",
    name: "newsDetails",
    component: () => import("../views/pages/news/newsDetails.vue"),
    props: true,
  },

  {
    path: "/program",
    name: "program",
    meta: {
      title: "PROGRAMS",
    },
    component: () => import("../views/pages/programs/index.vue"),
  },
  {
    path: "/services",
    name: "services",
    meta: {
      title: "SERVICES",
    },
    component: () => import("../views/pages/services/index.vue"),
  },
  {
    path: "/arcn-consult",
    name: "arcn-consult",
    meta: {
      title: "ARCN CONSULT",
    },
    component: () => import("../views/pages/services/index.vue"),
  },
  {
    path: "/arcn-tec-service",
    name: "arcn-tec-service",
    meta: {
      title: "ARCN TECHNICAL SERVICE",
    },
    component: () => import("../views/pages/services/index.vue"),
  },
  {
    path: "/arcn-media-service",
    name: "arcn-media-service",
    meta: {
      title: "ARCN MEDIA SERVICE",
    },
    component: () => import("../views/pages/services/index.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    meta: {
      title: "CONTACT ",
    },
    component: () => import("../views/pages/contact/index.vue"),
  },
];
